import React, {useState, useEffect} from 'react';
import {withRouter} from 'react-router-dom';
import {
    Button,
    DatePicker,
    message, Popconfirm,
    Space,
    Table,
    Upload
} from 'antd';
import PageContent from '../../components/page-content/page-content';
import Box from '../../components/box';
import {getAll, getDetail, postAdd, postRemove, updatefkrq} from "../../lib/api_cw_zcfkd";
import {UploadOutlined} from "@ant-design/icons";
import XLSX from "xlsx";
import moment, {isMoment} from "moment";
import ZcfkdEditModal from "./zcfkd_modal";


const {Column} = Table;


const Zcsj = (props) => {
    const [data, setData] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [loadingQYWX, setLoadingQYWX] = useState(false);
    const [loadingUpload, setLoadingUpload] = useState(false);
    const [detailModal, setDetailModal] = useState(null);
    // const [state, setState] = useUrlState({current: 1, pageSize: 10});
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });
    const [fkrq, setFkrq] = useState(null); // 付款日期


    /**
     * 获取数据
     */
    const fetchData = () => {
        console.log(tableParams);
        getAll({
            page: tableParams.pagination.current,
            size: tableParams.pagination.pageSize,
            filters: tableParams.filters
        })
            .then((res) => {
                if (res.code === 0) {
                    setData(res.data.records);
                    setTableParams({
                        ...tableParams,
                        pagination: {
                            ...tableParams.pagination,
                            total: res.data.total,
                        }
                    })
                }
            })
    }
    useEffect(fetchData, [JSON.stringify(tableParams)]);


    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
            setSelectedRows(selectedRowKeys);
        },
    };


    const handleTableChange = (pagination, filters, sorter) => {
        console.log(pagination, filters, sorter);
        setTableParams({
            pagination,
            filters,
            ...sorter,
        });
    };

    const hasSelected = selectedRows.length > 0;


    // 设置付款日期
    const handleSetFKRQ = () => {
        console.log(selectedRows, fkrq);
        updatefkrq(selectedRows, fkrq).then((res) => {
            if (res.code === 0) {
                message.success(res.message);
                fetchData();
            }
        })
    }

    return (
        <PageContent>
            <Box title={"支出数据"}>
                <Space>
                <span>
                  {hasSelected ? `已选择 ${selectedRows.length} 项` : ''}
                </span>
                    <DatePicker value={fkrq} onChange={(e) => setFkrq(e)}/>
                    <Button type="primary" disabled={!hasSelected || !fkrq}
                            onClick={handleSetFKRQ}>设置付款日期</Button>
                </Space>
                <Table
                    dataSource={data}
                    rowKey={"id"}
                    pagination={tableParams.pagination}
                    // size={"small"}
                    onChange={handleTableChange}

                    rowSelection={{
                        type: 'checkbox',
                        ...rowSelection,
                    }}
                    scroll={{
                        x: 700,
                        y: 600,
                    }}
                >
                    <Column title="编号" dataIndex="id" key="id" width={100}/>
                    {/*自动编号*/}
                    <Column title="创建日期" dataIndex="cjsj" key="cjsj" width={130}
                            render={(text) => {
                                if (text) {
                                    return moment(text).format('YYYY-MM-DD');
                                }
                                return text;
                            }}
                    />
                    <Column title="付款日期" dataIndex="fkrq" key="fkrq" width={130}
                            render={(text) => {
                                if (isMoment(text)) {
                                    return moment(text).format('YYYY-MM-DD');
                                }
                                return text;
                            }}
                    />
                    <Column title="笔数" dataIndex="bishu" key="bishu" width={130}
                            render={(text) => {
                                return text + '笔';
                            }}
                    />
                    <Column title="金额" dataIndex="hjje" key="hjje" width={130}
                            render={(text) => {
                                return text + '元';
                            }}
                    />
                    <Column title="操作" key="action" width={100} fixed="right"
                            render={(text, record) => {
                                return (
                                    <Space>
                                        <a onClick={() => {
                                            setDetailModal(record.id);
                                        }}>详情</a>
                                        <Popconfirm title="确认删除吗？" onConfirm={() => {
                                            postRemove(record.id).then((res) => {
                                                if (res.code === 0) {
                                                    message.success('删除成功');
                                                    fetchData();
                                                }
                                            }).catch((err) => {
                                                message.error(err.message);
                                            })
                                        }}>
                                            <a>删除</a>
                                        </Popconfirm>
                                    </Space>
                                )
                            }}
                    />
                </Table>
            </Box>

            {detailModal && <ZcfkdEditModal
                id={detailModal}
                onCancel={() => {
                    setDetailModal(null);
                }}
                onOk={() => {
                    setDetailModal(null);
                }}
            />}
        </PageContent>
    )
}

export default Zcsj;
